<template>
  <div :class="`message ${theme.isDark ? 'message_dark' : null}`">
    <div class="message__info">
      <p class="message__author" v-if="message.is_client_message">
        {{ message.customer_fullname }} | {{ message.customer_phone }}
      </p>
      <p class="message__author" v-else>
        {{ message.agent_fullname }} | {{ settings.default_phone }}
      </p>
      <p class="message__date">
        {{ createdAt }}
      </p>
    </div>
    <p class="text-subtitle-1 message__text">
      <span class="red--text" v-if="!message.send_status">
        <v-btn
          depressed
          color="error"
          :disabled="resended"
          @click="resendMessage(message.id)"
        >
          Resend
        </v-btn>
      </span>
      {{ message.text }}
    </p>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SortService from "@/services/sort.service";

export default {
  name: "Texts",
  inject: ["theme"],
  props: {
    message: Object,
  },
  data() {
    return {
      createdAt: SortService.formatDate(this.message.createdAt),
      resended: false,
    };
  },
  methods: {
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),
    resendMessage(id) {
      this.resended = true;

      this.$axios
        .post("/message/resend", {
          id: id,
        })
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
          if (res.code == 200) {
            this.resended = true;
          } else {
            this.resended = false;
          }
        })
        .catch((e) => {
          console.log(e);
          this.resended = false;
        });
    },
  },
  computed: {
    ...mapGetters({
      settings: "settings/settings",
    }),
  },
};
</script>

<style>
</style>